const oralSurgery = {
  hero: {
    badgeIconAlt: "Oralchirurgie-Symbol",
    badgeText: "Präzise orale Eingriffe",
    titleLine1: "Fortschrittliche Lösungen",
    titleLine2: "für Oralchirurgie",
    description:
      "Unsere erfahrenen Oralchirurgen bieten präzise Behandlungen für Extraktionen, Kieferprobleme und orale Pathologien unter Verwendung modernster Techniken für eine schnellere Heilung und optimale Ergebnisse.",
    ctas: {
      primary: "Beratungstermin vereinbaren",
      secondary: "Mehr über den Prozess der fortgeschrittenen Oralchirurgie erfahren",
    },
    heroImageAlt: "Fortschrittliche Oralchirurgie",
    stats: {
      successRateLabel: "Erfolgsquote",
      successRateValue: "97%+",
      recoveryLabel: "Genesung",
      recoveryValue: "Schneller",
    },
    experience: {
      label: "Chirurgische Exzellenz",
      value: "12+ Jahre Erfahrung",
    },
  },
  benefits: {
    heading: "WARUM UNSERE ORALCHIRURGIE WÄHLEN",
    intro:
      "Erleben Sie modernste chirurgische Verfahren mit optimalen Ergebnissen und Komfort.",
    items: [
      {
        title: "Präzisionsbehandlungen",
        description:
          "Unsere Chirurgen nutzen fortschrittliche Bildgebung und mikrochirurgische Techniken für höchste Präzision bei jedem Eingriff.",
      },
      {
        title: "Minimierte Beschwerden",
        description:
          "Moderne Anästhesieoptionen und minimalinvasive Techniken sorgen für Ihren Komfort vor, während und nach chirurgischen Eingriffen.",
      },
      {
        title: "Schnellere Genesung",
        description:
          "Unsere fortschrittlichen Ansätze führen zu verkürzten Heilungszeiten, weniger Schwellungen und einer schnelleren Rückkehr zu normalen Aktivitäten.",
      },
    ],
  },
  process: {
    heading: "DER CHIRURGISCHE PROZESS",
    intro: "Unser optimierter Ansatz gewährleistet außergewöhnliche Pflege und Ergebnisse.",
    steps: [
      {
        title: "Umfassende Bewertung",
        description:
          "Wir beginnen mit einer gründlichen Beurteilung Ihrer Mundgesundheit, Krankengeschichte und Bildgebung, um Ihren individuellen Behandlungsplan zu erstellen.",
      },
      {
        title: "Voroperative Vorbereitung",
        description:
          "Wir besprechen Anästhesieoptionen, geben detaillierte präoperative Anweisungen und beantworten alle Ihre Fragen, um sicherzustellen, dass Sie vollständig vorbereitet sind.",
      },
      {
        title: "Präziser chirurgischer Eingriff",
        description:
          "Unter Verwendung fortschrittlicher Techniken und Technologien führen unsere Chirurgen Ihren Eingriff mit außergewöhnlicher Präzision und Sorgfalt durch.",
      },
      {
        title: "Postoperative Versorgung",
        description:
          "Wir bieten umfassende Nachsorgeanweisungen und Nachuntersuchungen, um eine optimale Heilung und Ergebnisse zu gewährleisten.",
      },
    ],
  },
  faq: {
    heading: "HÄUFIG GESTELLTE FRAGEN",
    intro: "Erhalten Sie Antworten auf häufige Fragen zu unseren oralchirurgischen Eingriffen.",
    items: [
      {
        question: "Welche Arten von Oralchirurgie führen Sie durch?",
        answer:
          "Wir bieten ein umfassendes Spektrum oralchirurgischer Eingriffe an, einschließlich Weisheitszahnentfernung, Zahnimplantate, Knochenaufbau, Kieferchirurgie, Biopsien sowie Behandlung von Gesichtstraumata und Infektionen.",
      },
      {
        question: "Wie bereite ich mich auf die Oralchirurgie vor?",
        answer:
          "Die Vorbereitung hängt von Ihrem spezifischen Eingriff ab. Im Allgemeinen sollten Sie Nüchternheitsanweisungen befolgen, wenn Sie eine Sedierung erhalten, einen Transport nach Hause organisieren, bequeme Kleidung tragen und alle präoperativen Anweisungen unseres Teams befolgen.",
      },
      {
        question: "Wie lange dauert der Heilungsprozess?",
        answer:
          "Die Erholungszeit variiert je nach Eingriff und individuellen Heilungsfaktoren. Einfache Extraktionen erfordern möglicherweise nur wenige Tage, während komplexere Operationen 1-2 Wochen für die erste Erholung benötigen können. Wir werden Ihnen spezifische Zeiterwartungen für Ihren Eingriff mitteilen.",
      },
      {
        question: "Wird mein Eingriff schmerzhaft sein?",
        answer:
          "Ihr Komfort ist unsere Priorität. Wir verwenden moderne Anästhesietechniken, um sicherzustellen, dass Sie während des Eingriffs keine Schmerzen verspüren. Postoperative Beschwerden werden mit geeigneten Schmerzmitteln und detaillierten Nachsorgeanweisungen behandelt.",
      },
      {
        question: "Welche Risiken sind mit der Oralchirurgie verbunden?",
        answer:
          "Obwohl Oralchirurgie im Allgemeinen sicher ist, bergen alle chirurgischen Eingriffe gewisse Risiken, die Infektionen, Blutungen, Nervenschäden oder Reaktionen auf die Anästhesie umfassen können. Wir besprechen alle potenziellen Risiken ausführlich und treffen umfangreiche Vorkehrungen, um diese zu minimieren.",
      },
    ],
  },
};

export default oralSurgery;

